import React, { useEffect, useRef, useState } from "react";
import { useIdioma } from "../context/IdiomaContext";

const OPCIONES = [
  { codigo: "es", bandera: "🇳🇮", etiqueta: "Español" },
  { codigo: "de", bandera: "🇩🇪", etiqueta: "Deutsch" },
  { codigo: "en", bandera: "🇬🇧", etiqueta: "English" },
];

const SelectorIdioma = () => {
  const { idioma, setIdioma } = useIdioma();
  const [abierto, setAbierto] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const alHacerClickFuera = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setAbierto(false);
    };
    document.addEventListener("mousedown", alHacerClickFuera);
    return () => document.removeEventListener("mousedown", alHacerClickFuera);
  }, []);

  const actual = OPCIONES.find((o) => o.codigo === idioma) || OPCIONES[0];

  return (
    <div style={{ position: "relative" }} ref={ref}>
      <button
        onClick={() => setAbierto((v) => !v)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          background: "rgba(255,255,255,0.15)",
          color: "white",
          border: "1px solid rgba(255,255,255,0.35)",
          borderRadius: 999,
          padding: "6px 12px",
          fontSize: 12,
          fontWeight: 700,
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
      >
        <span style={{ fontSize: 15 }}>{actual.bandera}</span>
        {actual.codigo.toUpperCase()}
        <span style={{ fontSize: 10 }}>▾</span>
      </button>

      {abierto && (
        <div
          style={{
            position: "absolute",
            right: 0,
            marginTop: 6,
            background: "white",
            borderRadius: 12,
            boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
            overflow: "hidden",
            zIndex: 2000,
            minWidth: 150,
          }}
        >
          {OPCIONES.map((o) => (
            <button
              key={o.codigo}
              onClick={() => {
                setIdioma(o.codigo);
                setAbierto(false);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                width: "100%",
                padding: "10px 14px",
                border: "none",
                background: o.codigo === idioma ? "#eef2ff" : "white",
                color: "#1e293b",
                fontSize: 13,
                fontWeight: o.codigo === idioma ? 700 : 500,
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              <span style={{ fontSize: 16 }}>{o.bandera}</span>
              {o.etiqueta}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectorIdioma;
